// extracted by mini-css-extract-plugin
export default {"commandsPanel":"CommandsPanel_commandsPanel__-k1ob","commandsPanelSeparator":"CommandsPanel_commandsPanelSeparator__eYCaI"};